<template>
    <div class="visitor">
        <form class="search-haed" action="javascript:void 0" @submit.prevent="query">
            <div class="search">
                <div class="iconfont iconsearch"></div>
                <input  type="search" placeholder="请输入用户昵称" v-model="keyword" />
                <div class="chongzhi" @click="setReset()" v-if="listshow" >重置</div>
            </div>
        </form>
        <!-- <div class="text-box">
            <span>累计 {{count}}</span>
            <span>今日 {{todayCount}}</span>
        </div> -->
        <!-- <div class="tabs-content"  v-for="(items,indexs) in list" :key="indexs"> -->
            <!-- <div class="date-box">
                {{items.date}}·{{items.renCount}}人
            </div> -->
            <div class="tabs-content">
            <div class="list-box" v-for="(item,index) in list" :key="index">
                <div class="headimg">
                    <img :src="item.avatar"/>
                </div>
                <div class="info">
                    <div class="info-boxs">
                        <div class="info-box">
                            <div class="info-one">
                                <span class="name">{{item.nickname}}(编号:{{item.uid}})</span>
                            
                            </div>
                            <div class="info-two">
                                <span class="level">{{item.rank_name}}</span>
                                <span class="xinxin"><img :src="require('@assets/images/grade.png')" /></span>
                                <span class="repx">酒量值:{{item.pr}}</span>
                            </div>
                            <div class="info-two">
                                <span>所属店铺：{{item.store}}</span>
                                <!-- <span>粉丝{{item.userinfo.follow_number}}</span>
                                <span>内容{{item.userinfo.content}}</span>
                                <span>访问量{{item.userinfo.visit}}</span>
                                <span class="city-box">{{item.userinfo.city}}</span> -->
                            </div>
                        </div>
                        <div class="bottom-box">
                            <ToggleSwitch ref="ToggleSwitch" :speed='item.is_show_price?false:true' @change="isShow(item.uid,item.is_show_price?false:true)"></ToggleSwitch>
                        </div>
                    </div>
                    <div class="info-source">{{item.add_time}}</div>
                </div>
            </div>
            </div>
        <!-- </div> -->
        <div class="Loading" v-if="loading">
            <Loading size="24px">加载中...</Loading>
            </div>
            <div class="Loading" v-if="finished">没有更多了~</div>
        </div>
</template>

<script>
    import { getSpreadList,setUserShowPrice } from "@api/tasting";
    import FollowBit from './components/FollowBit';
    import ToggleSwitch from '../components/ToggleSwitch.vue';
    import { Icon, Toast, Tab  ,Loading } from "vant";
    export default {
        name: "visitor",
        data: function() {
            return {
                keyword:'',
                page:1,
                limit:20,
                list:[],
                loading:false,
                finished:false,
                listshow:false,
                count:0,
                todayCount:0,
                list_lengths:0,//列表长度
            };
        },
        components: {
            Icon, Toast, Tab ,Loading , FollowBit,ToggleSwitch
        },
        created: function() {
            
        }, 
        mounted: function() {
            this.Loadmore();
            var that=this;
            window.addEventListener("scroll", function(event) {
                var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
                if(document.documentElement.scrollHeight == document.documentElement.clientHeight + scrollTop) {
                    that.Loadmore();
                }
            });
        },
        methods: {
            isShow:function(uid,is_show){
                Toast.loading({
                    duration: 0,
                    message: '设置中',
                    forbidClick: true,
                });
                setUserShowPrice({
                    uid:uid,
                    is_show:is_show,
                }).then(res=>{
                    Toast.success({
                        message: res.msg,
                        forbidClick: true,
                    });
                     Toast.clear();
                }).catch(err=>{
                    Toast.success({
                        message: err.msg,
                        forbidClick: true,
                    });
                     Toast.clear();
                })
            },
            goPages: function(url) {
                this.$router.push({ path: url });
            },
            query(){
                this.getKeyword();
            },
            setdata(){
                this.loading = false;
                this.finished = false;
                this.page = 0;
                this.limit = 20;
                this.list=[];
                this.list_lengths=0;
            },
            setReset(){
                this.listshow = false;
                this.keyword = '';
                Toast.loading({
                    duration: 0,
                    message: '重置中...',
                    forbidClick: true,
                });
                this.setdata();
                this.Loadmore();
                Toast.clear();
            },
            Loadmore: function() {
                    if(this.loading) return;
                    if(this.finished) return;
                    this.getStoreUserLists();
            },
           getStoreUserLists:function(){
               this.loading = true;
               getSpreadList({
                   page:this.page,
                   limit:this.limit,
                   keyword:this.keyword,
                   grade:4
               }).then(res => {
                    this.count = res.data.count;
                    var listdata = res.data.list;
                    listdata.forEach((item)=>{
                        this.list.push(item);
                    })
                    this.loading = false;
                    this.page++;
                    this.list_lengths += listdata.length;
                    if(listdata.length<this.limit){
                        this.finished = true;
                    }
               }).catch(err => {
                    this.loading = false;
                    Toast.fail({
                        message: err.msg,
                        forbidClick: true,
                    });
                });
            },
            getKeyword(){
                getSpreadList({
                    page:this.page,
                    limit:this.limit,
                    keyword:this.keyword,
                    grade:4
                }).then(res => {
                    this.setdata();
                    var listdata = res.data.list;
                    listdata.forEach((item)=>{
                        this.list.push(item);
                    })
                    this.listshow = true;
                }).catch(err => {
                    Toast.fail({
                        message: err.msg,
                        forbidClick: true,
                    });
                });
            }
    },
           
}

</script>

<style scoped lang="scss">
    .visitor .tabs-content{
        background-color: #fff;
        //margin-top: 0.2rem;
    }
    .visitor .search-haed{
        width: 100%;
        height: 1rem;
        background-color: #fff;
        .search{
            margin: 0 auto;
            width: 90%;padding: 0.4rem 0;
            input{
                width: 100%;
                padding: 0.1rem 0.6rem;
                padding-right:0.8rem ;
                border: 1px solid #ccc;
                border-radius: 0.3rem;
                background-color: #ccc;
            }
            .iconfont{
                position: absolute;
                top: 0.5rem;
                left:7%;
            }
            .chongzhi{
                position: absolute;
                top: 0.5rem;
                right: 7%;
                z-index: 2;
            }
        }
    }
    .Loading{
        text-align: center;
        margin-top: 0.1rem;
        color: #ccc;
    }
    .visitor .text-box{
        background-color: #fff;
        padding:0.26rem ;
        margin-bottom: 0.2rem;
        span{
            padding: 0 0.2rem;
            padding-right:0 ;
            font-weight: 600;
            font-size: 0.4rem;

        }
    }
    .visitor .list-box .headimg{
        width: 40%;
        text-align: center;
        margin-top: 0.25rem;
    }
    .visitor .info{
        width: 85%;
        border-bottom: 1px solid #eee;
        padding: 0.1rem 0;
        .info-source{
            padding: 0.1rem;
        }
        

    }
    .visitor .info-boxs{
        display: flex;
        width: 100%;
       
    }
    .visitor .info-box{
        max-width: 77%;
        width: 77%;
    }
    .visitor .list-box{
        display: flex;
        .headimg{
            width: 1.2rem;
            height: 1.2rem;
            padding: 0.1rem;
            img{
                width: 100%;
                height: 100%;
                border-radius: 1rem;
            }  
        }
        .info-box .info-one {
            display: flex;
            padding: 0.1rem;
            margin-top: 0.1rem;
            align-items: center;
            span{
              margin: 0 0.06rem;
            } 
            .name{
                font-weight: 600;
                font-size: 0.3rem;
                color: #4b6886;
                //max-width: 20%;
            }
            
            
        }
        .info-box .info-two{
            .level{
                background-color: #f00;
                color: #fff;
                font-size: 0.2rem;
                padding:0.02rem 0.2rem; 
            }
            .xinxin{
                line-height: 0.1rem;
                img{
                width: 0.38rem;
                height: 0.38rem; 
                }
            }
            .repx{
                font-size: 0.2rem;
                color: #f00;
            }
        }
     }
    .visitor .tabs-content .info-box span img{
            width: 100%;
            height: 100%;
    }
    .visitor .tabs-content .info-box .info-two{
        font-size: 0.25rem;
        font-weight: 400;
        padding: 0 0.1rem;
        span{
            margin-left: 0.1rem;
            color: #767676;
        }
        .city-box{
            font-weight: 800;
            padding-left: 0.2rem;
        }
    }
    .visitor .date-box{
        width: 90%;
        margin-left: 10%;
        border-bottom: 1px solid #eee;
        padding: 0.3rem 0rem;
        font-size: 0.34rem;
    }


</style>